import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext(null);

const translations = {
  en: {
    // Common
    'jobAlerts': 'Job Alerts',
    'findYourDreamJob': 'Find your dream job opportunity',
    'currentStatistics': 'Current Statistics',
    'activeJobs': 'Active Jobs',
    'filterByQualification': 'Filter by Qualification',
    'allCategories': 'All Categories',
    'searchJobs': 'Search jobs by name, organization...',
    'sortBy': 'Sort By',
    'lastDate': 'Last Date (Ascending)',
    'lastDateAscending': 'Last Date (Ascending)',
    'lastDateDesc': 'Last Date (Descending)',
    'lastDateDescending': 'Last Date (Descending)',
    'createdAt': 'Newest First',
    'newestFirst': 'Newest First',
    'createdAtDesc': 'Oldest First',
    'oldestFirst': 'Oldest First',
    'notificationName': 'Name (A-Z)',
    'nameAZ': 'Name (A-Z)',
    'jobsFound': 'Jobs Found',
    'jobFound': 'Job Found',
    'noJobAlertsFound': 'No job alerts found',
    'tryAdjustingFilters': 'Try adjusting your filters or search query',
    'viewDetails': 'View Details',
    'lastDate': 'End / Last Date',
    'daysLeft': 'days left',
    'dayLeft': 'day left',
    'urgent': 'Urgent',
    'location': 'Location',
    'organization': 'Organization / Board',
    'vacancies': 'Vacancies / Slots',
    'qualification': 'Qualification / Eligibility',
    'ageLimit': 'Age Limit / Who Can Apply',
    'salary': 'Salary',
    'applicationFee': 'Fee / Charges',
    'description': 'Description',
    'eligibility': 'Eligibility',
    'importantDates': 'Important Dates',
    'requiredDocuments': 'Required Documents / Details',
    'viewNotification': 'View Notification / Update',
    'officialWebsite': 'Official Website',
    'examDate': 'Exam / Event Date',
    'resultDate': 'Result / Status Date',
    'applicationStart': 'Start Date',
    'notificationNameLabel': 'Notification / Online Update',
    'extractedFromURL': 'Extracted from URL',
    'allIndia': 'All India',
    'share': 'Share',
    'changeLanguage': 'Change Language',
    'clickLanguageButton': 'Click the language button above to change page language',
    
    // Categories
    'ssc': 'SSC / 10th',
    'inter': 'Inter / 12th',
    'degree': 'Degree',
    'btech': 'B.Tech',
    'iti': 'ITI / Diploma',
    'nursing': 'Nursing',
    'teacher': 'Teacher',
    'ttc': 'TTC / B.Ed',
    'hallTickets': 'Hall Tickets',
    'results': 'Results',
    'admissions': 'Admissions',
    'counsellingInfo': 'Web Counselling Info',
    'other': 'Other',
  },
  te: {
    // Common
    'jobAlerts': 'ఉద్యోగ సమాచారం',
    'findYourDreamJob': 'మీ కలల ఉద్యోగ అవకాశాన్ని కనుగొనండి',
    'currentStatistics': 'ప్రస్తుత గణాంకాలు',
    'activeJobs': 'క్రియాశీల ఉద్యోగాలు',
    'filterByQualification': 'అర్హత ద్వారా ఫిల్టర్ చేయండి',
    'allCategories': 'అన్ని వర్గాలు',
    'searchJobs': 'పేరు, సంస్థ ద్వారా ఉద్యోగాలను శోధించండి...',
    'sortBy': 'వర్గీకరించు',
    'lastDate': 'చివరి తేదీ (ఆరోహణ)',
    'lastDateAscending': 'చివరి తేదీ (ఆరోహణ)',
    'lastDateDesc': 'చివరి తేదీ (అవరోహణ)',
    'lastDateDescending': 'చివరి తేదీ (అవరోహణ)',
    'createdAt': 'కొత్తవి మొదట',
    'newestFirst': 'కొత్తవి మొదట',
    'createdAtDesc': 'పాతవి మొదట',
    'oldestFirst': 'పాతవి మొదట',
    'notificationName': 'పేరు (A-Z)',
    'nameAZ': 'పేరు (A-Z)',
    'jobsFound': 'ఉద్యోగాలు కనుగొనబడ్డాయి',
    'jobFound': 'ఉద్యోగం కనుగొనబడింది',
    'noJobAlertsFound': 'ఉద్యోగ హెచ్చరికలు కనుగొనబడలేదు',
    'tryAdjustingFilters': 'మీ ఫిల్టర్లు లేదా శోధన ప్రశ్నను సర్దుబాటు చేయడానికి ప్రయత్నించండి',
    'viewDetails': 'వివరాలను వీక్షించండి',
    'lastDate': 'ముగింపు / చివరి తేదీ',
    'daysLeft': 'రోజులు మిగిలాయి',
    'dayLeft': 'రోజు మిగిలింది',
    'urgent': 'అత్యవసరం',
    'location': 'స్థానం',
    'organization': 'సంస్థ / బోర్డు',
    'vacancies': 'ఖాళీలు / స్లాట్లు',
    'qualification': 'అర్హత / అర్హత వివరాలు',
    'ageLimit': 'వయస్సు పరిమితి / ఎవరు దరఖాస్తు చేయవచ్చు',
    'salary': 'జీతం',
    'applicationFee': 'రుసుం / ఛార్జీలు',
    'description': 'వివరణ',
    'eligibility': 'అర్హత',
    'importantDates': 'ముఖ్యమైన తేదీలు',
    'requiredDocuments': 'అవసరమైన పత్రాలు / వివరాలు',
    'viewNotification': 'నోటిఫికేషన్ / అప్‌డేట్ చూడండి',
    'officialWebsite': 'అధికారిక వెబ్‌సైట్',
    'examDate': 'పరీక్ష / ఈవెంట్ తేదీ',
    'resultDate': 'ఫలితం / స్థితి తేదీ',
    'applicationStart': 'ప్రారంభ తేదీ',
    'notificationNameLabel': 'నోటిఫికేషన్ / ఆన్‌లైన్ అప్‌డేట్',
    'extractedFromURL': 'URL నుండి సేకరించబడింది',
    'allIndia': 'అఖిల భారతదేశం',
    'share': 'షేర్ చేయండి',
    'changeLanguage': 'భాష మార్చండి',
    'clickLanguageButton': 'పేజీ భాషను మార్చడానికి పైన ఉన్న భాష బటన్ ని క్లిక్ చేయండి',
    
    // Categories
    'ssc': 'SSC / 10వ',
    'inter': 'ఇంటర్ / 12వ',
    'degree': 'డిగ్రీ',
    'btech': 'B.Tech',
    'iti': 'ITI / డిప్లొమా',
    'nursing': 'నర్సింగ్',
    'teacher': 'టీచర్',
    'ttc': 'TTC / B.Ed',
    'hallTickets': 'హాల్ టికెట్లు',
    'results': 'ఫలితాలు',
    'admissions': 'ప్రవేశాలు',
    'counsellingInfo': 'వెబ్ కౌన్సెలింగ్ సమాచారం',
    'other': 'ఇతర',
  },
  hi: {
    // Common
    'jobAlerts': 'नौकरी अलर्ट',
    'findYourDreamJob': 'अपने सपनों की नौकरी का अवसर खोजें',
    'currentStatistics': 'वर्तमान आंकड़े',
    'activeJobs': 'सक्रिय नौकरियां',
    'filterByQualification': 'योग्यता के अनुसार फ़िल्टर करें',
    'allCategories': 'सभी श्रेणियां',
    'searchJobs': 'नाम, संगठन द्वारा नौकरियां खोजें...',
    'sortBy': 'क्रमबद्ध करें',
    'lastDate': 'अंतिम तिथि (आरोही)',
    'lastDateAscending': 'अंतिम तिथि (आरोही)',
    'lastDateDesc': 'अंतिम तिथि (अवरोही)',
    'lastDateDescending': 'अंतिम तिथि (अवरोही)',
    'createdAt': 'नवीनतम पहले',
    'newestFirst': 'नवीनतम पहले',
    'createdAtDesc': 'सबसे पुराना पहले',
    'oldestFirst': 'सबसे पुराना पहले',
    'notificationName': 'नाम (A-Z)',
    'nameAZ': 'नाम (A-Z)',
    'jobsFound': 'नौकरियां मिलीं',
    'jobFound': 'नौकरी मिली',
    'noJobAlertsFound': 'कोई नौकरी अलर्ट नहीं मिला',
    'tryAdjustingFilters': 'अपने फ़िल्टर या खोज प्रश्न को समायोजित करने का प्रयास करें',
    'viewDetails': 'विवरण देखें',
    'lastDate': 'अंतिम तिथि',
    'daysLeft': 'दिन बचे',
    'dayLeft': 'दिन बचा',
    'urgent': 'जरूरी',
    'location': 'स्थान',
    'organization': 'संगठन / बोर्ड',
    'vacancies': 'रिक्तियां / स्लॉट',
    'qualification': 'योग्यता / पात्रता',
    'ageLimit': 'आयु सीमा / कौन आवेदन कर सकता है',
    'salary': 'वेतन',
    'applicationFee': 'शुल्क / चार्ज',
    'description': 'विवरण',
    'eligibility': 'पात्रता',
    'importantDates': 'महत्वपूर्ण तिथियां',
    'requiredDocuments': 'आवश्यक दस्तावेज / विवरण',
    'viewNotification': 'अधिसूचना / अपडेट देखें',
    'officialWebsite': 'आधिकारिक वेबसाइट',
    'examDate': 'परीक्षा / इवेंट तिथि',
    'resultDate': 'परिणाम / स्थिति तिथि',
    'applicationStart': 'प्रारंभ तिथि',
    'notificationNameLabel': 'अधिसूचना / ऑनलाइन अपडेट',
    'share': 'साझा करें',
    'extractedFromURL': 'URL से निकाला गया',
    'allIndia': 'पूरे भारत',
    'share': 'साझा करें',
    'changeLanguage': 'भाषा बदलें',
    'clickLanguageButton': 'पृष्ठ भाषा बदलने के लिए ऊपर दिए गए भाषा बटन पर क्लिक करें',
    
    // Categories
    'ssc': 'SSC / 10वीं',
    'inter': 'इंटर / 12वीं',
    'degree': 'डिग्री',
    'btech': 'B.Tech',
    'iti': 'ITI / डिप्लोमा',
    'nursing': 'नर्सिंग',
    'teacher': 'शिक्षक',
    'ttc': 'TTC / B.Ed',
    'hallTickets': 'हॉल टिकट',
    'results': 'परिणाम',
    'admissions': 'प्रवेश',
    'counsellingInfo': 'वेब काउंसलिंग जानकारी',
    'other': 'अन्य',
  },
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Get saved language from localStorage or default to English
    const saved = localStorage.getItem('preferredLanguage');
    return saved && translations[saved] ? saved : 'en';
  });

  useEffect(() => {
    // Save language preference
    localStorage.setItem('preferredLanguage', language);
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations.en[key] || key;
  };

  // Translate job notification content (qualification, organization, etc.)
  const translateJobContent = (text) => {
    if (!text || language === 'en') return text;
    
    const lowerText = text.toLowerCase().trim();
    
    // Qualification translations
    const qualTranslations = {
      te: {
        '10th': '10వ తరగతి',
        '10th class': '10వ తరగతి',
        '10th standard': '10వ తరగతి',
        '10th std': '10వ తరగతి',
        'ssc': 'SSC',
        'ssc / 10th': 'SSC / 10వ',
        'inter': 'ఇంటర్',
        'intermediate': 'ఇంటర్',
        '12th': '12వ తరగతి',
        '12th class': '12వ తరగతి',
        '12th standard': '12వ తరగతి',
        '12th std': '12వ తరగతి',
        'inter / 12th': 'ఇంటర్ / 12వ',
        'degree': 'డిగ్రీ',
        'graduation': 'డిగ్రీ',
        'bachelor': 'డిగ్రీ',
        'b.tech': 'B.Tech',
        'btech': 'B.Tech',
        'iti': 'ITI',
        'diploma': 'డిప్లొమా',
        'nursing': 'నర్సింగ్',
        'teacher': 'టీచర్',
        'teaching': 'టీచింగ్',
        'ttc': 'TTC',
        'b.ed': 'B.Ed',
        'bed': 'B.Ed',
        'ttc / b.ed': 'TTC / B.Ed',
        'pg': 'PG',
        'post graduate': 'PG',
        'm.tech': 'M.Tech',
        'mtech': 'M.Tech',
        'mba': 'MBA',
        'phd': 'PhD',
        'class': 'తరగతి',
        'standard': 'తరగతి',
        'std': 'తరగతి',
      },
      hi: {
        '10th': '10वीं',
        '10th class': '10वीं कक्षा',
        '10th standard': '10वीं कक्षा',
        '10th std': '10वीं कक्षा',
        'ssc': 'SSC',
        'ssc / 10th': 'SSC / 10वीं',
        'inter': 'इंटर',
        'intermediate': 'इंटर',
        '12th': '12वीं',
        '12th class': '12वीं कक्षा',
        '12th standard': '12वीं कक्षा',
        '12th std': '12वीं कक्षा',
        'inter / 12th': 'इंटर / 12वीं',
        'degree': 'डिग्री',
        'graduation': 'स्नातक',
        'bachelor': 'स्नातक',
        'b.tech': 'B.Tech',
        'btech': 'B.Tech',
        'iti': 'ITI',
        'diploma': 'डिप्लोमा',
        'nursing': 'नर्सिंग',
        'teacher': 'शिक्षक',
        'teaching': 'शिक्षण',
        'ttc': 'TTC',
        'b.ed': 'B.Ed',
        'bed': 'B.Ed',
        'ttc / b.ed': 'TTC / B.Ed',
        'pg': 'PG',
        'post graduate': 'स्नातकोत्तर',
        'm.tech': 'M.Tech',
        'mtech': 'M.Tech',
        'mba': 'MBA',
        'phd': 'PhD',
        'class': 'कक्षा',
        'standard': 'कक्षा',
        'std': 'कक्षा',
      },
    };

    // Common organization/terms translations
    const orgTranslations = {
      te: {
        'staff selection commission': 'సిబ్బంది ఎంపిక కమిషన్',
        'ssc': 'SSC',
        'railway recruitment board': 'రైల్వే నియామక బోర్డు',
        'rrb': 'RRB',
        'intelligence bureau': 'ఇంటెలిజెన్స్ బ్యూరో',
        'ib': 'IB',
        'union public service commission': 'యూనియన్ పబ్లిక్ సర్వీస్ కమిషన్',
        'upsc': 'UPSC',
        'all india': 'అఖిల భారతదేశం',
        'extracted from url': 'URL నుండి సేకరించబడింది',
        'years': 'సంవత్సరాలు',
        'year': 'సంవత్సరం',
        'days': 'రోజులు',
        'day': 'రోజు',
        'months': 'నెలలు',
        'month': 'నెల',
        'rupees': 'రూపాయలు',
        'rupee': 'రూపాయి',
        'rs': 'రూ',
        '₹': 'రూ',
        'posts': 'పోస్టులు',
        'post': 'పోస్ట్',
        'posts the': 'పోస్టులు',
        'recruitment': 'నియామకం',
        'recruitment of': 'నియామకం',
        'specialist cadre officers': 'స్పెషలిస్ట్ క్యాడర్ అధికారులు',
        'officers': 'అధికారులు',
        'officer': 'అధికారి',
        'state bank of india': 'స్టేట్ బ్యాంక్ ఆఫ్ ఇండియా',
        'sbi': 'SBI',
        'application fee': 'దరఖాస్తు రుసుము',
        'fee': 'రుసుము',
        'general': 'జనరల్',
        'obc': 'OBC',
        'sc': 'SC',
        'st': 'ST',
        'ph': 'PH',
        'ews': 'EWS',
      },
      hi: {
        'staff selection commission': 'कर्मचारी चयन आयोग',
        'ssc': 'SSC',
        'railway recruitment board': 'रेलवे भर्ती बोर्ड',
        'rrb': 'RRB',
        'intelligence bureau': 'खुफिया ब्यूरो',
        'ib': 'IB',
        'union public service commission': 'संघ लोक सेवा आयोग',
        'upsc': 'UPSC',
        'all india': 'पूरे भारत',
        'extracted from url': 'URL से निकाला गया',
        'years': 'वर्ष',
        'year': 'वर्ष',
        'days': 'दिन',
        'day': 'दिन',
        'months': 'महीने',
        'month': 'महीना',
        'rupees': 'रुपये',
        'rupee': 'रुपया',
        'rs': 'रु',
        '₹': 'रु',
        'posts': 'पद',
        'post': 'पद',
        'posts the': 'पद',
        'recruitment': 'भर्ती',
        'recruitment of': 'भर्ती',
        'specialist cadre officers': 'विशेषज्ञ कैडर अधिकारी',
        'officers': 'अधिकारी',
        'officer': 'अधिकारी',
        'state bank of india': 'भारतीय स्टेट बैंक',
        'sbi': 'SBI',
        'application fee': 'आवेदन शुल्क',
        'fee': 'शुल्क',
        'general': 'सामान्य',
        'obc': 'OBC',
        'sc': 'SC',
        'st': 'ST',
        'ph': 'PH',
        'ews': 'EWS',
      },
    };

    const langTranslations = { ...qualTranslations[language] || {}, ...orgTranslations[language] || {} };
    
    // Try exact match first
    if (langTranslations[lowerText]) {
      return langTranslations[lowerText];
    }
    
    // Try partial matches for compound terms (longer keys first for better matching)
    let translated = text;
    const sortedKeys = Object.keys(langTranslations).sort((a, b) => b.length - a.length);
    
    sortedKeys.forEach((key) => {
      // Match whole words or phrases (case-insensitive)
      const regex = new RegExp(`\\b${key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'gi');
      if (regex.test(translated.toLowerCase())) {
        translated = translated.replace(regex, (match) => {
          // Preserve original case for first letter if it was uppercase
          const matchIndex = translated.toLowerCase().indexOf(match.toLowerCase());
          if (matchIndex !== -1) {
            const originalMatch = translated.substring(matchIndex, matchIndex + match.length);
            if (originalMatch && originalMatch[0] === originalMatch[0].toUpperCase()) {
              return langTranslations[key].charAt(0).toUpperCase() + langTranslations[key].slice(1);
            }
          }
          return langTranslations[key];
        });
      }
    });
    
    // Special handling for "10th class", "12th class" patterns
    if (language === 'te') {
      translated = translated.replace(/\b10th\s+class\b/gi, '10వ తరగతి');
      translated = translated.replace(/\b12th\s+class\b/gi, '12వ తరగతి');
      translated = translated.replace(/\b(\d+)(th|nd|rd|st)\s+class\b/gi, (match, num) => {
        const teluguNums = ['', 'ఒక', 'రెండు', 'మూడు', 'నాలుగు', 'ఐదు', 'ఆరు', 'ఏడు', 'ఎనిమిది', 'తొమ్మిది', 'పది'];
        return num <= 10 ? `${teluguNums[parseInt(num)]}వ తరగతి` : `${num}వ తరగతి`;
      });
      
      // Handle "Posts The" pattern (e.g., "996 Posts The State Bank")
      translated = translated.replace(/\b(\d+)\s+posts\s+the\b/gi, (match, num) => `${num} పోస్టులు`);
      translated = translated.replace(/\b(\d+)\s+posts\b/gi, (match, num) => `${num} పోస్టులు`);
      translated = translated.replace(/\bposts\s+the\b/gi, 'పోస్టులు');
      
      // Handle "recruitment of" pattern
      translated = translated.replace(/\brecruitment\s+of\s+(\d+)\s+([^.]*?)\s+posts?\b/gi, (match, num, desc) => {
        return `${num} ${desc} పోస్టుల నియామకం`;
      });
      translated = translated.replace(/\brecruitment\s+of\b/gi, 'నియామకం');
    } else if (language === 'hi') {
      translated = translated.replace(/\b10th\s+class\b/gi, '10वीं कक्षा');
      translated = translated.replace(/\b12th\s+class\b/gi, '12वीं कक्षा');
      translated = translated.replace(/\b(\d+)(th|nd|rd|st)\s+class\b/gi, (match, num) => `${num}वीं कक्षा`);
      
      // Handle "Posts The" pattern (e.g., "996 Posts The State Bank")
      translated = translated.replace(/\b(\d+)\s+posts\s+the\b/gi, (match, num) => `${num} पद`);
      translated = translated.replace(/\b(\d+)\s+posts\b/gi, (match, num) => `${num} पद`);
      translated = translated.replace(/\bposts\s+the\b/gi, 'पद');
      
      // Handle "recruitment of" pattern
      translated = translated.replace(/\brecruitment\s+of\s+(\d+)\s+([^.]*?)\s+posts?\b/gi, (match, num, desc) => {
        return `${num} ${desc} पदों की भर्ती`;
      });
      translated = translated.replace(/\brecruitment\s+of\b/gi, 'भर्ती');
    }
    
    // If no translation found, return original
    return translated !== text ? translated : text;
  };

  const changeLanguage = (lang) => {
    if (translations[lang]) {
      setLanguage(lang);
    }
  };

  const value = {
    language,
    t,
    translateJobContent,
    changeLanguage,
    languages: [
      { code: 'en', name: 'English', nativeName: 'English' },
      { code: 'te', name: 'Telugu', nativeName: 'తెలుగు' },
      { code: 'hi', name: 'Hindi', nativeName: 'हिंदी' },
    ],
  };

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

